
export default {
  'employeeLogin.title': 'Login',
  'employeeLogin.edit': 'Edit Profile',
  'employeeLogin.login': 'Login',
  'employeeLogin.save': 'Save & Continue',
  'employeeLogin.cancel': 'Cancel',
  'employeeLogin.create': 'New Profile',

  'employeeLogin.login.header': 'Log In',
  'employeeLogin.login.subtitle': "You are almost ready. Confirm your account details, select your branch location, and click the 'Login' button.",
  'employeeLogin.login.help': "Review the details of your profile below. If you need to edit your profile, click the 'Edit Profile' button below. Once you confirm that all your information is correct, click the 'Login' button.",
  'employeeLogin.login.branchList': 'Select which branch you would like to log in with:',
  'employeeLogin.login.branchList.alert': 'You must select a branch before you log in.',

  'employeeLogin.edit.header': 'Edit Your Profile',
  'employeeLogin.edit.subtitle': "Enter your information and select branches for your account. When you are finished, click the 'Save & Continue' button.",

  'employeeLogin.branches.search.label': 'Search for branches:',
  'employeeLogin.branches.search.placeholder': 'Start typing to search...',
  'employeeLogin.branches.search.help': 'Results from the branch search will be shown here.',
  'employeeLogin.branches.search.empty': 'No branches were found. Please try another search.',
  'employeeLogin.branches.assigned': 'Associated Branches:',
  'employeeLogin.branches.assigned.help': "No branches associated with this profile. Use the 'search for branch' section above to search and add a branch.",
  'employeeLogin.branches.assigned.error': 'At least one branch association is required.',

  'employeeLogin.formInput.firstName': 'First Name:',
  'employeeLogin.formInput.firstName.placeholder': 'First Name',
  'employeeLogin.formInput.firstName.error': 'Invalid first name',
  'employeeLogin.formInput.lastName': 'Last Name:',
  'employeeLogin.formInput.lastName.placeholder': 'Last Name',
  'employeeLogin.formInput.lastName.error': 'Invalid last name',
  'employeeLogin.formInput.email': 'Email:',
  'employeeLogin.formInput.email.placeholder': 'user@email.com',
  'employeeLogin.formInput.email.error': 'Invalid email',
  'employeeLogin.formInput.phone': 'Phone Number:',
  'employeeLogin.formInput.phone.placeholder': '(555) 123-4567',
  'employeeLogin.formInput.phone.error': 'Invalid phone #',
  'employeeLogin.formInput.employeeId': 'Employee ID:',
  'employeeLogin.formInput.employeeId.placeholder': 'Employee ID',
  'employeeLogin.formInput.employeeId.error': 'Invalid ID',
  'employeeLogin.formInput.nmlsId': 'NMLS ID Number:',
  'employeeLogin.formInput.nmlsId.placeholder': 'NMLS #',
  'employeeLogin.formInput.nmlsId.error': 'Enter numbers only',
  'employeeLogin.formInput.isRequired': 'Required',

  'employeeLogin.search.header': 'Select Your Profile',
  'employeeLogin.search.subtitle': 'To select your profile, you can search for a previously created account or create a new profile.',
  'employeeLogin.search': 'Search',
  'employeeLogin.search.label': 'Enter your employee id, name, email address, or phone number to search for your profile:',
  'employeeLogin.search.placeholder': 'Search for profile',
  'employeeLogin.search.results.empty': 'No results found.  Search again or click "New Profile" below to create a profile.',
  'employeeLogin.search.results.description': 'Click a profile to log in',
  'employeeLogin.search.empty': 'No results found. Search again or click the "New Profile" button below to create a account.',

  'employeeLogin.conflicts': 'Profile(s) have been found that conflict with fields entered above:',

  'employeeLogin.flowStep.profile': 'Choose your profile',
  'employeeLogin.flowStep.branch': 'Select a branch',
  'employeeLogin.flowStep.login': 'Log in',
};
